<li class='squire'>
    <b *ngIf="title !== ''" >{{title}}&nbsp;</b>
    <span *ngIf="description !==''" [innerHTML]="_description"></span>
</li>
